import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "default-form" }
const _hoisted_2 = { class: "input-row" }
const _hoisted_3 = { class: "input-wr" }
const _hoisted_4 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_5 = { class: "input-wr" }
const _hoisted_6 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_7 = { class: "input-row align-start" }
const _hoisted_8 = {
  key: 0,
  class: "input-wr"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "input-wr" }
const _hoisted_11 = { class: "input-row" }
const _hoisted_12 = { class: "input-wr" }
const _hoisted_13 = { class: "file-label" }
const _hoisted_14 = ["accept"]
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "input-row" }
const _hoisted_17 = { class: "input-wr" }
const _hoisted_18 = { class: "toggle-block" }
const _hoisted_19 = { class: "toggle-description" }
const _hoisted_20 = { class: "bold" }
const _hoisted_21 = { class: "input-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[15] || (_cache[15] = _createElementVNode("div", { class: "dashboard-header" }, [
      _createElementVNode("h2", { class: "title-main" }, "Update Estate")
    ], -1)),
    _createElementVNode("form", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[6] || (_cache[6] = _createElementVNode("label", { class: "label" }, "Title", -1)),
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass(["input", { error: $setup.v$.title.$error }]),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.title) = $event)),
            type: "text",
            placeholder: "Title"
          }, null, 2), [
            [
              _vModelText,
              $setup.form.title,
              void 0,
              { trim: true }
            ]
          ]),
          ($setup.v$.title.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString($setup.v$.title.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[7] || (_cache[7] = _createElementVNode("label", { class: "label" }, "Address", -1)),
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass(["input", { error: $setup.v$.address.$error }]),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.address) = $event)),
            type: "text",
            placeholder: "Address"
          }, null, 2), [
            [
              _vModelText,
              $setup.form.address,
              void 0,
              { trim: true }
            ]
          ]),
          ($setup.v$.address.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString($setup.v$.address.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        ($setup.estate && $setup.estate.logoUrl)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _cache[8] || (_cache[8] = _createElementVNode("label", { class: "label" }, "Current Logo", -1)),
              _createElementVNode("img", {
                class: "logo",
                src: $setup.estate.logoUrl
              }, null, 8, _hoisted_9)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_10, [
          _cache[9] || (_cache[9] = _createElementVNode("label", { class: "label" }, "Icon Color", -1)),
          _createElementVNode("label", {
            class: "input-color",
            style: _normalizeStyle({ 'background-color': $setup.form.iconColor })
          }, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.iconColor) = $event)),
              type: "color"
            }, null, 512), [
              [_vModelText, $setup.form.iconColor]
            ])
          ], 4)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("label", _hoisted_13, [
            _cache[10] || (_cache[10] = _createTextVNode("Choose Logo", -1)),
            _createElementVNode("input", {
              onChange: _cache[3] || (_cache[3] = ($event: any) => ($setup.selectFile($event))),
              type: "file",
              accept: $setup.logoTypes
            }, null, 40, _hoisted_14),
            ($setup.file)
              ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString($setup.file.name), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "toggle-title" }, "Initial deposit", -1)),
            _createVNode($setup["ToggleButton"], {
              modelValue: $setup.form.isRefundable,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.form.isRefundable) = $event)),
              label: "Refundable"
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_19, [
              _cache[11] || (_cache[11] = _createTextVNode("Buyers will be notified before submitting", -1)),
              _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
              _cache[13] || (_cache[13] = _createTextVNode(" a Contract information form that the holding deposit is", -1)),
              _createElementVNode("span", _hoisted_20, _toDisplayString(`${$setup.form.isRefundable ? "" : " not"} refundable.`), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("button", {
          class: "button default outlined cancel-btn",
          onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.router.go(-1))),
          type: "button"
        }, "Cancel"),
        _createElementVNode("button", {
          class: "button default primary create-btn",
          onClick: $setup.updateEstate,
          type: "button"
        }, "Update")
      ])
    ])
  ], 64))
}